import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, PhoneOff, Video } from 'lucide-react';
import { useCall } from '../../context/CallContext';
import useRingTone from './useRingTone';
import './Calls.css';

export default function IncomingCallModal() {
    const { status, call, acceptCall, rejectCall } = useCall();
    const visible = status === 'incoming' && call;

    useRingTone(visible, 'incoming');

    // Con la ventana minimizada o en otra pestaña el modal no se ve: aviso del sistema
    // mientras suene (en la app de escritorio, al tocarlo saca la ventana de la bandeja).
    useEffect(() => {
        if (!visible || !('Notification' in window) || Notification.permission !== 'granted') return undefined;
        if (document.visibilityState === 'visible' && document.hasFocus()) return undefined;
        let notif;
        try {
            notif = new Notification(call.caller_name || 'Llamada entrante', {
                body: call.call_type === 'video' ? 'Videollamada entrante' : 'Llamada entrante',
                icon: '/logo192.png',
                tag: `llamada-${call.room_uuid}`,
                requireInteraction: true,
            });
            notif.onclick = () => {
                window.focus();
                notif.close();
            };
        } catch {
            return undefined;
        }
        return () => notif.close();
    }, [visible, call]);

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    className="call-modal-backdrop"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <motion.div
                        className="call-modal"
                        initial={{ scale: 0.85, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.85, opacity: 0 }}
                        transition={{ type: 'spring', stiffness: 260, damping: 22 }}
                    >
                        <div className="call-modal-type">
                            {call.call_type === 'video' ? <Video size={18} /> : <Phone size={18} />}
                            <span>{call.call_type === 'video' ? 'Videollamada entrante' : 'Llamada entrante'}</span>
                        </div>

                        <div className="call-modal-avatar">
                            {call.caller_foto ? (
                                <img src={call.caller_foto} alt={call.caller_name} />
                            ) : (
                                <span>{call.caller_name?.charAt(0).toUpperCase()}</span>
                            )}
                        </div>

                        <div className="call-modal-name">{call.caller_name}</div>

                        <div className="call-modal-actions">
                            <button
                                className="call-btn call-btn-reject"
                                onClick={rejectCall}
                                title="Rechazar"
                            >
                                <PhoneOff size={26} />
                            </button>
                            <button
                                className="call-btn call-btn-accept"
                                onClick={acceptCall}
                                title="Aceptar"
                            >
                                {call.call_type === 'video' ? <Video size={26} /> : <Phone size={26} />}
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
